import React from 'react'
import { InputSelectOptions } from 'components'
import {
  InputField,
  UploadImageField
} from 'components/molecules'
import { Card } from 'reactstrap'
import { ACTIVE_STATUS, DESCRIPTION } from 'domains/cms-blog-post/constants'
import CategoryAsyncMultiselectField from 'domains/cms-blog-post/molecules/async-multiselect-field'
import PropTypes from 'prop-types'

const propTypes = {
  formikBag    : PropTypes.object,
  heroImage    : PropTypes.object,
  setHeroImage : PropTypes.func,
  isEditAction : PropTypes.bool
}

const defaultProps = {
  formikBag    : {},
  heroImage    : new Blob(),
  setHeroImage : () => {},
  isEditAction : false
}

const BlogPostDetailFields = ({
  formikBag,
  heroImage,
  setHeroImage,
  isEditAction
}) => (
  <>
    <h2> Main Page </h2>

    <Card body>
      <InputField
        type='text'
        name='title'
        label='Title'
        placeholder='Simpel dan Nyaman, Ini 3 Items Wajib Musim Panas 2021'
        required={ true }
      />
      <InputField
        type='text'
        name='url'
        label='Url'
        placeholder='most-comfortable-summer-trends'
        required={ true }
        disabled={ isEditAction }
      />
      <p>{ DESCRIPTION.URL }</p>

      <UploadImageField
        id='output-hero-image'
        label='Cover Image'
        image={ heroImage }
        initialImageSrc={ formikBag.values.hero_img_url }
        setValue={ (input) => {
          setHeroImage(input)
        } }
      />

      <InputField
        type='select'
        label={ 'Active Status' }
        name={ 'active_status' }
        required={ true }
      >
        <InputSelectOptions options={ ACTIVE_STATUS } keyPrefix={ 'active-status' } />
      </InputField>

      <CategoryAsyncMultiselectField
        name={ 'category' }
        label='Category [fashion,lifestyle,sustainable lifestyle,beauty,event]'
        placeholder='Select Category'
        isEditAction={ isEditAction }
        required={ true }
      />
      <p>{ DESCRIPTION.CATEGORY }</p>

      <InputField
        type='textarea'
        rows='5'
        label='Summary'
        name='summary'
        required={ true }
      />
      <p>{ DESCRIPTION.SUMMARY }</p>
    </Card>
  </>
)

BlogPostDetailFields.propTypes    = propTypes
BlogPostDetailFields.defaultProps = defaultProps

export default BlogPostDetailFields
